/**
 * SHX Collection navigator — arrows, overflow detection, and auto-scrolling the
 * active category into view. ES module, custom-element lifecycle (theme-editor safe).
 */

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

class ShxCnav extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;

    this.scroller = this.querySelector('[data-shx-scroller]');
    if (!this.scroller) return;
    const prev = this.querySelector('[data-shx-scroll="-1"]');
    const next = this.querySelector('[data-shx-scroll="1"]');
    const dirFlip = document.body.dataset.rtl === 'true' ? -1 : 1;

    const update = () => {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const pos = Math.abs(this.scroller.scrollLeft);
      const overflowing = max > 4;
      this.classList.toggle('is-overflowing', overflowing);
      if (prev) prev.hidden = !overflowing || pos <= 4;
      if (next) next.hidden = !overflowing || pos >= max - 4;
    };

    const step = (dir) =>
      this.scroller.scrollBy({
        left: dir * dirFlip * this.scroller.clientWidth * 0.7,
        behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth',
      });

    prev?.addEventListener('click', () => step(-1), { signal });
    next?.addEventListener('click', () => step(1), { signal });
    this.scroller.addEventListener('scroll', update, { passive: true, signal });

    this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(update));
    this.resizeObserver.observe(this.scroller);

    // Center the current category on load — scrolls only this strip, never the
    // page (scrollIntoView would also scroll the window to the section).
    const active = this.querySelector('.shx-cnav__item--active');
    requestAnimationFrame(() => {
      if (active && document.body.dataset.rtl !== 'true') {
        this.scroller.scrollLeft = active.offsetLeft - (this.scroller.clientWidth - active.offsetWidth) / 2;
      }
      update();
    });
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('shx-cnav')) customElements.define('shx-cnav', ShxCnav);
